// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dialog {\n  font-family: Solomon Sans;\n}\n.dialog-button {\n  border: 0;\n  cursor: pointer;\n  min-width: 84px;\n}\n", ""]);
// Exports
module.exports = exports;
